import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { Button } from '../../../../../cdl/Button/Button';
import { useToasts } from '../../../../../cdl/Toast/useToasts';
import { Tooltip } from '../../../../../cdl/Tooltip/Tooltip';
import { UpdateOrderRequest } from '../../../../../common/api/clients/order.api';
import { translate } from '../../../../../common/helpers/translate.helper';
import AppSettings from '../../../../../constants';
import { useSurvicateContext } from '../../../../../survicate/useSurvicateContext';
import { toUpdateOrderRequest } from '../../../../model/order.mapper';
import { OrderState } from '../../../../model/OrderModel';
import { ConfirmOrderModal } from '../../../components/OfferCard/components/ConfirmOrderModal';
import { useOfferCardContext } from '../../../components/OfferCard/hooks/useOfferCardContext';
import { useOrderUpdate } from '../../../hooks/useOrderUpdate';

interface OrderButtonProps {
    disabled?: boolean;
}

export const OrderButton = ({ disabled = false }: OrderButtonProps) => {
    const { offer, order } = useOfferCardContext();
    const [isOpen, setIsOpen] = useState(false);
    const { addErrorToast } = useToasts();
    const navigate = useNavigate();

    const survicate = useSurvicateContext();
    const SURVEY_DELAY_IN_MS = 5000;

    const orderUpdateMutation = useOrderUpdate();

    const createOrder = () => {
        const closedOrder: UpdateOrderRequest = {
            ...toUpdateOrderRequest(order),
            state: OrderState.CLOSED,
            chosenOfferId: offer.id,
        };

        orderUpdateMutation.mutate(
            {
                order: closedOrder,
                orderId: order.id,
            },
            {
                onSuccess: () => {
                    setTimeout(() => {
                        survicate?.showSurvey(AppSettings.survicateSurveyId.customer);
                    }, SURVEY_DELAY_IN_MS);

                    navigate({ to: '/offer/$id', params: { id: offer.id } });
                },
                onError: () => {
                    setIsOpen(false);
                    addErrorToast(translate('global.genericToastError'));
                },
            }
        );
    };

    const button = (
        <Button emphasis="high" width="100%" onClick={() => setIsOpen(true)} disabled={disabled}>
            {translate('approvalRequest.buttons.orderNow')}
        </Button>
    );

    return (
        <div>
            {disabled ? (
                <Tooltip label={translate('approvalRequest.buttons.orderNowDisabledTooltip')}>{button}</Tooltip>
            ) : (
                button
            )}

            <ConfirmOrderModal
                isOpen={isOpen}
                onDismiss={() => setIsOpen(false)}
                onConfirm={createOrder}
                isLoading={orderUpdateMutation.isPending}
            />
        </div>
    );
};
